import React, { useRef } from "react";
import { NumberOrderApi } from "../../../../../services/Api/Public/types";
import NumberSystemCard from "./NumberSystemCard";

interface Props {
	items: NumberOrderApi[];
}

const NumberSystemSection = ({ items }: Props) => {
	const parentRef = useRef<HTMLDivElement>(null);

	return (
		<div className="number-system-section" ref={parentRef}>
			{items.map((item, index) => (
				<NumberSystemCard key={`${item.id}-${index}`} item={item} parentRef={parentRef} />
			))}
		</div>
	);
};

export default NumberSystemSection;
